import SystemUpdatePage from '@/views/system/SystemUpdate.vue';
import SystemStatsPage from '@/views/system/SystemStats.vue';
import SystemLogsPage from '@/views/system/SystemLogs.vue';
import SystemRegionPage from '@/views/system/SystemRegion.vue';
import SystemInfoPage from '@/views/system/SystemInfo.vue';
import SystemStoragePage from '@/views/system/SystemStoragePage.vue';

export default class SystemRoutes {
  public static Routes = [
    {
      path: 'info',
      name: 'system-info',
      component: SystemInfoPage,
      meta: {
        label: 'Information',
      },
    },
    {
      path: 'region',
      name: 'system-region',
      component: SystemRegionPage,
      meta: {
        label: 'Regional settings',
      },
    },
    {
      path: 'stats',
      name: 'system-stats',
      component: SystemStatsPage,
      meta: {
        label: 'Resources',
      },
    },
    {
      path: 'storage',
      name: 'system-storage',
      component: SystemStoragePage,
      meta: {
        label: 'Storage',
      },
    },
    {
      path: 'update',
      name: 'system-update',
      component: SystemUpdatePage,
      meta: {
        label: 'Update',
      },
    },
    {
      path: 'logs',
      name: 'system-logs',
      component: SystemLogsPage,
      meta: {
        label: 'Logs',
      },
    },
  ];
}
